module.exports = __webpack_public_path__ + "media/images/gallery/constellations/coma_berenices/com_lines-ebfa414b4f3a3d85f7491e8fe7506410.gif";